/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// TinyMCE React component
import { Editor } from "@tinymce/tinymce-react";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../../apiClient";

function EditPage({ onClose, onSuccess, data }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const editdata = data;

  const [formData, setFormData] = useState({
    name: editdata.name || "",
    description: editdata.description || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEditorChange = (content, editor) => {
    setFormData({
      ...formData,
      description: content, // Update the description field with the editor content
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    try {
      console.log("Form data submitted:", formData);
      const response = await apiClient.post("/admin/cms", formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "error") {
          console.error("Error creating faq:", response.data.message);
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error("Error creating faq:", error);
    }
  };

  return (
    <Card id="add-cms">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Editor
                apiKey="co7iog08j50n616b97281yqig5porxb4vabfkxp622emhn47" // Replace with your TinyMCE API key
                value={formData.description}
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "link",
                    "image",
                    "charmap",
                    "print",
                    "preview",
                    "anchor",
                    "searchreplace",
                    "wordcount",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | bullist numlist | link image",
                }}
                onEditorChange={handleEditorChange} // Capture changes to TinyMCE editor
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default EditPage;
